import PROPERTIES from '../../../../properties';
import { onRouteSearch as onRouteSearchWithProps } from '../../../onRouteSearch';
import { FlatInjectionObj } from '../../../../../../../../store/types/prescription';
import { INJECTION_COLUMN } from '../../../../../../../../utils/enums';
import AntAutoCompleteV2 from '../../../AntAutoComplete';
import { EditableCellV2 } from '../../../MedTableRenderer';
import { injectionRowHeaderMapping } from '../../../../../../../../constants';
import { INJECTIONS_TABLE_CONTAINER } from '../InjectionTable';
import { useDispatch, useSelector } from 'react-redux';
import { getInjectionElements } from '../../../../../../../../store/selectors/prescriptionPad';
import { upsertInjection } from '../../../../../../../../store/actions/prescriptionPad';

const InjectionRoute = ({
    injection,
    columnKey,
}: {
    injection: FlatInjectionObj;
    columnKey: INJECTION_COLUMN;
}): JSX.Element => {
    const elements = useSelector(getInjectionElements);
    const dispatch = useDispatch();
    const onRouteSearch = (value: string): Promise<string[]> => {
        return onRouteSearchWithProps(
            value,
            PROPERTIES.injection.Route.map((route) => route.n),
        );
    };
    const onRouteSelect = (value?: string | undefined) => {
        const { mainIndex } = injection;
        const clonedElement = elements[mainIndex];
        if (clonedElement) {
            clonedElement.route = value || '';
        }
        dispatch(upsertInjection(clonedElement, mainIndex));
    };
    return (
        <div className="hover-parent-element">
            <EditableCellV2
                fieldName={columnKey}
                defaultValue={injection.route || ''}
                label={injectionRowHeaderMapping[columnKey]}
            >
                <AntAutoCompleteV2
                    autoFocus
                    onSearch={onRouteSearch}
                    selectedValue={injection.route || ''}
                    debounceDelay={200}
                    getLabelToCompare={(o) => o}
                    placeholder={'Route'}
                    customDropdownWidth={180}
                    onSelect={onRouteSelect}
                    key={`Injection-${columnKey}`}
                    containerIdToAttachDropdown={INJECTIONS_TABLE_CONTAINER}
                />
            </EditableCellV2>
        </div>
    );
};

export default InjectionRoute;
